import { publicCatalogApi } from '@/features/publicsite/catalog/api/publicCatalogApi';
import { CatalogCard } from '@/features/publicsite/catalog/CatalogCard';
import { CatalogSection } from '@/features/publicsite/catalog/CatalogSection';
import { institutionSubtitle } from '@/features/publicsite/catalog/trainingInstitutionProfile';
import type { TrainingInstitution } from '@/features/publicsite/types/training/TrainingInstitution';
import { usePublicList } from '@/features/publicsite/usePublicList';
import { publicCatalog } from '@/i18n/dictionaries/publicCatalog';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * /instruiri/institutii — the directory §6.5 asks for, in the shape /cercetare/organizatii has.
 *
 * The counts are the two facts a reader chooses between institutions on: how much it teaches and
 * whether anything is open now. An institution approved before the profile existed has neither a
 * subtitle nor a domain to show, and reads as its name alone rather than as a card of blanks.
 */
export function TrainingInstitutionsPage() {
  const { t, language } = useTranslation(publicCatalog);
  const institutions = usePublicList<TrainingInstitution>(publicCatalogApi.trainingInstitutionsUrl);

  return (
    <CatalogSection
      eyebrow={t('eyebrowCatalog')}
      heading={t('institutionsHeading')}
      lead={t('institutionsLead')}
      items={institutions}
      renderCard={(institution) => (
        <CatalogCard
          key={institution.id}
          id={`institutie-${institution.id}`}
          to={`/instruiri/institutii/${institution.id}`}
          badge={t('institutionPrograms', { count: institution.programCount ?? 0 })}
          title={institution.name}
          subtitle={institutionSubtitle(institution, language)}
        >
          <p className="muted">
            {t('institutionUpcoming', { count: institution.upcomingSessionCount ?? 0 })}
          </p>
        </CatalogCard>
      )}
    />
  );
}
